<div class="about-content">
  <mat-card appearance="outlined" class="testy1">
    <mat-card-content>
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Programming languages: </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-chip-set>
            @for (skillObj of skillList; track skillObj) {
              @if (skillObj.list === "Programming") {
                <mat-chip color="accent" highlighted>
                  {{ skillObj.skill }}
                </mat-chip>
              }
            }
          </mat-chip-set>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Frameworks:</mat-panel-title>
          </mat-expansion-panel-header>
          <mat-chip-set>
            @for (skillObj of skillList; track skillObj) {
              @if (skillObj.list === "Frameworks") {
                <mat-chip color="accent" highlighted>
                  {{ skillObj.skill }}
                </mat-chip>
              }
            }
          </mat-chip-set>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Designing:</mat-panel-title>
          </mat-expansion-panel-header>
          <mat-chip-set>
            @for (skillObj of skillList; track skillObj) {
              @if (skillObj.list === "Designs") {
                <mat-chip color="accent" highlighted>
                  {{ skillObj.skill }}
                </mat-chip>
              }
            }
          </mat-chip-set>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Databases:</mat-panel-title>
          </mat-expansion-panel-header>
          <mat-chip-set>
            @for (skillObj of skillList; track skillObj) {
              @if (skillObj.list === "Databases") {
                <mat-chip color="accent" highlighted>
                  {{ skillObj.skill }}
                </mat-chip>
              }
            }
          </mat-chip-set>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Frameworks:</mat-panel-title>
          </mat-expansion-panel-header>
          <mat-chip-set>
            @for (skillObj of skillList; track skillObj) {
              @if (skillObj.list === "Frameworks") {
                <mat-chip color="accent" highlighted>
                  {{ skillObj.skill }}
                </mat-chip>
              }
            }
          </mat-chip-set>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Designing:</mat-panel-title>
          </mat-expansion-panel-header>
          <mat-chip-set>
            @for (skillObj of skillList; track skillObj) {
              @if (skillObj.list === "Designs") {
                <mat-chip color="accent" highlighted>
                  {{ skillObj.skill }}
                </mat-chip>
              }
            }
          </mat-chip-set>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Databases:</mat-panel-title>
          </mat-expansion-panel-header>
          <mat-chip-set>
            @for (skillObj of skillList; track skillObj) {
              @if (skillObj.list === "Databases") {
                <mat-chip color="accent" highlighted>
                  {{ skillObj.skill }}
                </mat-chip>
              }
            }
          </mat-chip-set>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Methodologies: </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-chip-set>
            @for (skillObj of skillList; track skillObj) {
              @if (skillObj.list === "Methodologies") {
                <mat-chip color="accent" highlighted>
                  {{ skillObj.skill }}
                </mat-chip>
              }
            }
          </mat-chip-set>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Tools:</mat-panel-title>
          </mat-expansion-panel-header>
          <mat-chip-set>
            @for (skillObj of skillList; track skillObj) {
              @if (skillObj.list === "Tools") {
                <mat-chip color="accent" highlighted>
                  {{ skillObj.skill }}
                </mat-chip>
              }
            }
          </mat-chip-set>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Cloud Platforms:</mat-panel-title>
          </mat-expansion-panel-header>
          <mat-chip-set>
            @for (skillObj of skillList; track skillObj) {
              @if (skillObj.list === "Cloud") {
                <mat-chip color="accent" highlighted>
                  {{ skillObj.skill }}
                </mat-chip>
              }
            }
          </mat-chip-set>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Cloud Platforms:</mat-panel-title>
          </mat-expansion-panel-header>
          <mat-chip-set>
            @for (skillObj of skillList; track skillObj) {
              @if (skillObj.list === "Cloud") {
                <mat-chip color="accent" highlighted>
                  {{ skillObj.skill }}
                </mat-chip>
              }
            }
          </mat-chip-set>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>
  </mat-card>
</div>
